import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "29",
  height: "29",
  viewBox: "0 0 29 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "mask0_11697_12125",
      style: {"mask-type":"alpha"},
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "29",
      height: "29"
    }, [
      _createElementVNode("rect", {
        width: "29",
        height: "29",
        fill: "#D9D9D9"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#mask0_11697_12125)" }, [
      _createElementVNode("path", {
        d: "M12.8087 20.0587L21.3274 11.5399L19.6357 9.84824L12.8087 16.6753L9.36491 13.2316L7.67324 14.9232L12.8087 20.0587ZM14.5003 26.5837C12.8288 26.5837 11.258 26.2665 9.78783 25.6321C8.31769 24.9977 7.03887 24.1368 5.95137 23.0493C4.86387 21.9618 4.00293 20.683 3.36855 19.2128C2.73418 17.7427 2.41699 16.1719 2.41699 14.5003C2.41699 12.8288 2.73418 11.258 3.36855 9.78783C4.00293 8.31769 4.86387 7.03887 5.95137 5.95137C7.03887 4.86387 8.31769 4.00293 9.78783 3.36855C11.258 2.73418 12.8288 2.41699 14.5003 2.41699C16.1719 2.41699 17.7427 2.73418 19.2128 3.36855C20.683 4.00293 21.9618 4.86387 23.0493 5.95137C24.1368 7.03887 24.9977 8.31769 25.6321 9.78783C26.2665 11.258 26.5837 12.8288 26.5837 14.5003C26.5837 16.1719 26.2665 17.7427 25.6321 19.2128C24.9977 20.683 24.1368 21.9618 23.0493 23.0493C21.9618 24.1368 20.683 24.9977 19.2128 25.6321C17.7427 26.2665 16.1719 26.5837 14.5003 26.5837Z",
        fill: "#17346D"
      })
    ], -1)
  ]))]))
}
export default { render: render }